define('frontend-common-components/modalController/modalController',[
        'marionette',
        'jquery',
        '../utils/utils'
    ],
    function (Marionette, $, utils) {
        'use strict';

        return Marionette.Controller.extend({

            initialize: function (options) {
                this.selector = options.selector;
                this.handleModalDefaultFocus();
            },

            showModal: function (view, options) {
                options = options || {};
                view.render();
                $(this.selector).html(view.el);
                $(this.selector).modal(options);
            },

            handleModalDefaultFocus: function () {
                $(this.selector).on('shown.bs.modal', function () {
                    $('input[placeholder]').placeholder();
                    if (!utils.isIE()) {
                        $(this).find('[autofocus]:first').focus();
                    }
                });
            }

        });

    });
